import { RootState } from '@Common/models/redux/store';
import { getReduxStore } from 'src/redux';

export function showCookieLinks() {
  const countryCode = (getReduxStore()?.getState() as RootState)?.common?.countryCode;
  if (!countryCode || countryCode === 'XX') return true;
  // Europe, Liechtenstein, Iceland, Canada, United Kingdom
  if (['EU', 'LI', 'IS', 'CA', 'GB'].includes(countryCode || '')) {
    return true;
  }
  return false;
}

export function openConsentForm() {
  if (!showCookieLinks()) return;
  const opt = (window as any).Optanon;
  if (opt) opt.ToggleInfoDisplay();
}

export function hasUserRejectedAnalyticsCookies() {
  const opt = (window as any).Optanon;
  if (!opt) return false;
  const activeGroups = (window as any).OptanonActiveGroups;
  const isEnabled = (activeGroups || '').includes('C0002');
  if (isEnabled) return false;
  return true;
}
